<div class=" row m-3">

    @for (terrain of clientTerrain; track terrain.id) {
            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Description :</span>
                <p>{{ terrain.description }}</p>
            </div>
            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Exploitation :</span>
  <p>{{ terrain.exploitationName }}</p>
            </div>
            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Var plante :</span>
                <p>{{ terrain.varPlante }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Status :</span>
                <p>{{ terrain.actif ? 'Actif' : 'Inactif' }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Date de plantation :</span>
                <p>{{ terrain.datePlantation }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Longitude :</span>
                <p>{{ terrain.lon }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Latitude :</span>
                <p>{{ terrain.lat }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Créé le :</span>
                <p>{{ terrain.creationDate | date:'dd/MM/yyyy' }}</p>
            </div>

            <div class="col-md-4 col-lg-3 mt-3">
                <span class="label">Mis à jour le :</span>
                <p>{{ terrain.updateDate | date:'dd/MM/yyyy' }}</p>
            </div>
        <hr class="mt-3" *ngIf="!$last"/>
    } @empty {
        <div style="height: 200px">Aucun détails de terrain disponible.</div>
    }
</div>



